import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { DashboardLayout, Icon, Loader, ThemeIcon } from '../../components'
import { currencyFmt } from '../../utils'

import Transaction from './Transaction'
import './Coin.scss'
import SendCoin from './SendCoin'
import ReceiveCoin from './ReceiveCoin'
import TxnList from '../../components/TxnList'
import { useSelector } from 'react-redux'
import clsx from 'clsx'

const Coin = () => {
   const history = useHistory()
   const { coinId, transactionId } = useParams()
   const { isDarkTheme } = useSelector(state => state.theme)

   const [coin, setCoin] = React.useState(null)
   const [transactions, setTransactions] = React.useState([])
   const [selectedTransaction, setSelectedTransaction] = React.useState(null)
   const [isLoading, setIsLoading] = React.useState(true)
   const [isSending, setIsSending] = React.useState(false)
   const [isReceiving, setIsReceiving] = React.useState(false)

   React.useEffect(() => {
      ;(async () => {
         try {
            setIsLoading(true)
            if (transactionId) {
               // fetch transaction
               setSelectedTransaction({
                  id: 1,
                  type: 'RECEIVED',
                  value: 1.02,
                  unit: 'BNB',
                  createdAt: '2021-08-06T17:35:19.954Z',
                  status: 'COMPLETED',
                  sender: '0X10EDJ767SSGV7885GS5T124EGY6758F24E',
                  recipient: null,
                  networkFee: 0.23,
                  nonce: 85,
               })
            } else {
               // fetch all transactions of this coin
               setCoin({
                  id: coinId,
                  name: 'Binance Coin',
                  image: 'https://via.placeholder.com/32',
                  value: 1.997696,
                  unit: 'BNB',
                  investedAmount: 535,
                  transactions: [
                     {
                        id: 1,
                        type: 'RECEIVED',
                        sender: '0X10EDJ767SSGV7885GS5T124EGY6758F24E',
                        value: 1.02,
                        createdAt: '2021-08-06T17:35:19.954Z',
                     },
                     {
                        id: 2,
                        type: 'SENT',
                        recipient: '0X10EDJ767SSGV7885GS5T124EGY6758F24E',
                        value: 0.56,
                        createdAt: '2021-08-06T17:35:19.954Z',
                     },
                     {
                        id: 3,
                        type: 'SMART_CONTRACT_CALL',
                        recipient: '0X10EDJ767SSGV7885GS5T124EGY6758F24E',
                        value: 0.0,
                        createdAt: '2021-08-05T17:35:19.954Z',
                     },
                  ],
               })
            }
         } catch (err) {
            console.log(err)
         } finally {
            setIsLoading(false)
         }
      })()
   }, [coinId, transactionId])

   React.useEffect(() => {
      if (coin?.transactions?.length) {
         setTransactions(coin.transactions)
      }
   }, [coin])

   if (isLoading) return <Loader />
   if (transactionId && selectedTransaction)
      return <Transaction transaction={selectedTransaction} />
   if (isSending)
      return (
         <SendCoin onBackClick={() => setIsSending(false)} unit={coin.unit} />
      )
   if (isReceiving)
      return (
         <ReceiveCoin
            onBackClick={() => setIsReceiving(false)}
            unit={coin.unit}
         />
      )
   return (
      <DashboardLayout
         withNav={false}
         className={clsx('Coin', isDarkTheme && 'Coin--dark')}
      >
         <header className="Coin__header">
            <div className="Coin__header-left">
               <Icon
                  className="Coin__header-left-back"
                  name="chevron-left"
                  onClick={() => history.push(`/wallet/coins`)}
               />
               <span className="Coin__header-left-name">{coin.name}</span>
               <img
                  src={coin.image}
                  alt={coin.name}
                  className="Coin__header-left-image"
               />
            </div>
            <div className="Coin__header-right">
               <ThemeIcon
                  className="Coin__header-right-icon"
                  name="upload"
                  onClick={() => setIsSending(true)}
               />
               <ThemeIcon
                  className="Coin__header-right-icon"
                  name="download"
                  onClick={() => setIsReceiving(true)}
               />
            </div>
         </header>
         <div className="Coin__details">
            <h2 className="Coin__details-value">
               {coin.value} {coin.unit}
            </h2>
            <small className="Coin__details-invested">
               {currencyFmt(coin.investedAmount)}
            </small>
         </div>
         <TxnList
            className="Coin__txns"
            transactions={transactions}
            ticker={coin.unit}
            onTxnClick={txn => history.push(`/coin/${coinId}/${txn.id}`)}
            isDarkTheme={isDarkTheme}
         />
      </DashboardLayout>
   )
}

export default Coin
